// extracted by mini-css-extract-plugin
export var animationContainer = "_f8-0";
export var asteriskIcon = "_f8-8";
export var conversationLeftSection = "_f8-4";
export var conversationListItem = "_f8-3";
export var conversationMiddleSection = "_f8-5";
export var conversationRightSection = "_f8-6";
export var detailsContent = "_f8-1";
export var listContainer = "_f8-7";
export var modalContent = "_f8-2";